<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">Crew Average Age Per Rank List</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-10 text-left">
        <div class="form-inline d-flex justify-content-start w-100">
          <div class="form-group py-1 mx-3" v-if="isPrincipal">
            <label for="manning" class="form-control-xs font-weight-bold">Select Manning: </label>
            <select name="manning" id="manning" class="form-control form-control-xs mx-2"
                    v-model="params.manningId" :disabled="isLoading">
              <option :value="null" id="manningOption0" disabled selected>---Select Manning ---</option>
              <option value="">ALL MANNING</option>
              <option v-for="manningKey in getManningLists"
                      :key="manningKey.id"
                      :title="manningKey.name"
                      :value="manningKey.id">
                {{ manningKey.alias }}
              </option>
            </select>
          </div>
          <div class="form-group py-1 mx-3">
            <label for="rank" class="form-control-xs font-weight-bold">Select Rank: </label>
            <select name="rank" id="rank" class="form-control form-control-xs mx-2"
                    v-model="params.rankType" :disabled="isLoading">
              <option :value="null" id="rankOption0" disabled selected>---Select Rank Type ---</option>
              <option value="">ALL RANKS</option>
              <option v-for="rankTypeKey in rankTypeKeys"
                      :key="rankTypeKey.id"
                      :value="rankTypeKey.id"
                      :title="rankTypeKey.name"
              >{{ rankTypeKey.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-2 text-center d-flex justify-content-end align-items-center">
        <button :disabled="params.manningId === null && params.rankType === null"
                class="btn btn-primary btn-xs p-1 d-flex align-items-center"
                v-if="!isLoading" @click="downloadAgeAverage">
          <i class="fas fa-file-pdf fa-2x mx-1"></i>
          Generate Report
        </button>
      </div>
      <div class="col col-12">
        <div class=" table-responsive my-2">
          <table class="table table-hover table-bordered table-template-1 text-small table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Code</th>
                <th>Name</th>
                <th>Min Age</th>
                <th>Max Age</th>
                <th>Average Age</th>
                <th>Total Crew</th>
              </tr>
            </thead>

            <tbody class="text-small">
            <tr v-if="isLoading">
              <td colspan="100%">
                <app-loading></app-loading>
              </td>
            </tr>

            <template v-else>
              <tr v-for="(rank, index) in rankAgeAverage.ranks" :key="rank.id">
                <td class="text-center">{{index + 1}}</td>
                <td class="text-center">{{rank.rankAlias}}</td>
                <td class="text-center">{{rank.rankName}}</td>
                <td class="text-center">{{rank.minAge}}</td>
                <td class="text-center">{{rank.maxAge}}</td>
                <td class="text-center">{{rank.avgAge ? rank.avgAge.toFixed(0) : 0}}</td>
                <td class="text-center">{{rank.crewCount}}</td>
              </tr>
            </template>
            </tbody>
          </table>
          </div>
      </div>
    </div>
    <download-pdf-loading></download-pdf-loading>
  </div>
</template>

<script>
import {vueAppMixin} from '../../../../mixins/vueAppMixin';
import {gateMixin} from '../../../../mixins/gateMixin';
import AppLoading from '../../../elements/AppLoading';
import DownloadPDFLoading from '../../../elements/DownloadPDFLoading';
import {mapActions, mapGetters} from 'vuex';
import {ReportService} from '../../../../services/ReportService';

export default {
  name: 'GenerateAgeAverage',
  mixins: [vueAppMixin, gateMixin],
  components: {
    AppLoading,
    'download-pdf-loading': DownloadPDFLoading
  },
  data() {
    return {
      params: {
        manningId: null,
        rankType: null,
      },
      modalLoad: false
    };
  },
  methods: {
    ...mapActions([
      'getRankTypeKeys',
      'getManningKeys',
      'getAgePerRankReport',
      'setLoading',
    ]),

    async downloadAgeAverage(){
      this.modalLoad = true
      document.getElementById('LoadingModal').style.display = 'block'
      !this.params.manningId ? this.params.manningId = '' : this.params.manningId;
      !this.params.rankType ? this.params.rankType = '' : this.params.rankType;
      await ReportService.generateAgePerRankFile(this.params);
      this.modalLoad = false
      document.getElementById('LoadingModal').style.display = 'none'
    }

  },
  computed: {
    ...mapGetters([
      'rankTypeKeys',
      'manningKeys',
      'rankAgeAverage'
    ]),

    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    }
  },
  created(){
    this.getRankTypeKeys();
    this.getManningKeys();
    this.setLoading(false);
  },
  watch: {
    'params.manningId'() {
      this.getAgePerRankReport(this.params);
      document.getElementById('manningOption0').style.display = 'none';
      // document.getElementById('generateReport').style.display = 'block';
    },
    'params.rankType'() {
      this.getAgePerRankReport(this.params);
      document.getElementById('rankOption0').style.display = 'none'
      // document.getElementById('generateReport').style.display = 'block';
    },
  }

};
</script>

<style scoped>

</style>
